import styled from 'styled-components';

export const Container = styled.a`
  background-color: #ffffff;
  padding: 0.5rem 0.5rem;
  border-radius: 3em;
  margin: 0.5rem;
  display: flex;
  justify-items: center;
  align-items: center;

  img {
    width: 1.15rem;
    height: 1.15rem;
    vertical-align: middle;
  }

  &:hover {
    background-color: gray;
    transition: 0.3s;
  }

  @media (max-width: 420px) {
    img {
      width: 1.3rem;
      height: 1.3rem;
    }
  }
`;
